export default __webpack_public_path__ + "static/media/clone.ebc02ab5.svg";